import React, { useEffect, useState } from "react";
import Pagination from "react-js-pagination";
import { dateAdnTimeFormatUtc, dateFormatUtc, dateFormatWithTime } from "../../../utils/dateFormat";


const UserMeditationHistory = ({
  handlePageChange,
  total,
  activePage,
  orderList,
}) => {
console.log('total', total)
  return (
    <>
      
      <div className="content-table">
        <table>
          <thead>
            <tr>
              <th>S. No.</th>
              <th>User Name</th>
              <th>User Id</th>
              <th>Meditation Open Time</th>
              <th>Total Time Spent</th>
              <th>Meditation Type</th>
              <th>Meditation Name</th>
              <th>Total Play</th>
              <th>Repeat Play</th>
            </tr>
          </thead>
          <tbody>
            {orderList.length > 0 ? (
              orderList.map((order, index) => (
               <tr>
                <td>{order?.serialNumber || '---'}</td>
                <td>{order?.userName || '---'}</td>
                <td>{order?.userId || '---'}</td>
                <td>{dateAdnTimeFormatUtc(order?.meditationOpenTime) || '---'}</td>
                <td>{order?.totalTimeSpent} Sec</td>
                <td>{order?.meditationType || '---'}</td>
                <td>{order?.meditationName || '---'}</td>
                <td>{order.totalPlay}</td>
                <td>{order.repeatPlay}</td>
               </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8">No Order Found!</td>
              </tr>
            )}
          </tbody>
        </table>
        {total > 1 ? (
          <div className="pagination-wrapper">
            <div className="Pagination">
              <Pagination
                activePage={activePage}
                previousLabel={"previous"}
                nextLabel={"next"}
                itemsCountPerPage={10}
                totalItemsCount={total}
                pageRangeDisplayed={10}
                onChange={handlePageChange}
                hideDisabled={true}
              />
            </div>
          </div>
        ) : null}
      </div>
    </>
  );
};
export default UserMeditationHistory;



